<template>
  <div class="admin-report-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <adminFilter
        :minHeight="minHeight"
        :disabled="false"
        :title="'分析報告搜尋'"
        :filters="{
          init: init,
          options: filterOptions
        }"
        @changeFilters="(c, search) => { filters = c; search && searchDatas(c) }"
      ></adminFilter>
    </div>
    <div class="main-container row-block" :style="{ flex: 1, height: minHeight }">
      <div v-if="onSearch" class="mask center-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div class="main-block col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <div class="title-container row-block">
          <div class="title">分析報告管理</div>
          <div :style="{ flex: 1 }"></div>
          <button type="button" name="button" class="main-button option-button update" @click="e => editReport()">
            <span>新增報告</span>
          </button>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="table-feild col-block" :style="{ flex: 1 }">
          <div class="table-container col-block" :style="{ height: '50px' }">
            <div class="thead default-shadow">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="option.class"
                  :style="option.width ? { width: option.width } : { flex: 1 }"
                  @click="e => option.sort !== false && tableSortBy(option.value)"
                >
                  <span>{{ option.title }}</span>
                  <div :style="{ width: '5px' }"></div>
                  <i v-if="option.sort !== false" :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
            <div class="tbody" :style="{ flex: 1 }">
              <div :style="{ height: 0 }">
                <div class="tr row-block" v-for="(report, cindex) in reports" :key="cindex">
                  <div class="container-block row-block">
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="option.class"
                      :style="option.width ? { width: option.width } : { flex: 1 }"
                    >
                      <div v-if="option.value === '_OPTIONS'">
                        <div class="option row-block">
                          <div class="row-block" :style="{ flex: 1 }">
                            <button type="button" name="button" class="main-button option-button update" @click="e => editReport(report)">
                              <span>編輯</span>
                            </button>
                            <div :style="{ flex: 1 }"></div>
                          </div>
                          <div :style="{ width: '20px' }"></div>
                          <div class="row-block">
                            <button type="button" name="button" class="main-button delete" @click="e => deleteAdminReport(report)">
                              <i class="fa fa-trash-o" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="option.value === 'title'" :style="{ width: '100%' }">
                        <div class="title row-block">
                          <span :title="(option.display || (x => x))(report[option.value], cindex)" :style="(option.style || (() => {}))(report[option.value])">{{ (option.display || (x => x))(report[option.value], cindex) || '--' }}</span>
                          <div :style="{ width: '15px' }"></div>
                          <div class="row-block" :style="{ width: '42px', 'flex-shrink': 0 }">
                            <img v-if="report.has_cover_photo" :src="require('../../assets/images/report-cover-icon.svg')">
                            <div v-else :style="{ flex: 1 }"></div>
                            <img v-if="report.has_attachments" :src="require('../../assets/images/report-link-icon.svg')">
                            <div v-else :style="{ flex: 1 }"></div>
                          </div>
                        </div>
                      </div>
                      <span v-else :title="(option.display || (x => x))(report[option.value], cindex)" :style="(option.style || (() => {}))(report[option.value])">{{ (option.display || (x => x))(report[option.value], cindex) || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-container center-block">
            <pageButtons
              v-if="pageData.total"
              :default="pageData.selectedPage"
              :display="pageData.display"
              :total="pageData.total"
              :buttonRange="pageData.buttonRange"
              @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
            ></pageButtons>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getProductByCategorys, getAdminReports, deleteAdminReport } from '../../api'
import adminFilter from '../../components/admin/filter'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { dateFormat } from '../../constants/global/util'

export default {
  components: {
    adminFilter,
    pageButtons
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      reports: [],
      productByCategorys: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: ['publish_time'],
        order: ['-desc']
      }
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    categoryOptions () {
      return [
        ...Object.keys(this.productByCategorys).map(category => ({ title: category, value: category })),
        { title: '其他', value: '其他' }
      ]
    },
    productOptions () {
      return [
        ...Array.prototype.concat.apply([], Object.entries(this.productByCategorys).map(([category, products]) => Object.entries(products).map(([code, product]) => ({ title: product.chinese_name, value: code, type: product.product_type, category: category })))),
        { title: '其他', value: '其他', type: '其他', category: '其他' }
      ]
    },
    moduleOptions () {
      return [
        { title: '市場吸引力', value: 'market_attractiveness' },
        { title: '市場競爭力', value: 'market_competitiveness' },
        { title: '零售價格分析', value: 'product_prices' },
        { title: '其他', value: 'others' }
      ]
    },
    yearOptions () {
      let year = (new Date()).getFullYear()
      return [
        { title: '無', value: '無' },
        ...(new Array(year - 2000)).fill('').map((_, i) => ({ title: year - i + '', value: year - i + '' }))
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    // static
    filterOptions () {
      return [
        {
          title: '標題關鍵字',
          value: 'title',
          type: 'input',
          placeholder: () => '如：產業報告...等'
        },
        {
          title: '產品類別',
          value: 'category',
          type: 'select',
          options: this.categoryOptions,
          placeholder: () => '水果、蔬菜、農業機械...等',
          onChange: (value, conditions) => {
            setTimeout(() => {
              this.init = {
                ...this.init,
                ...conditions,
                product_code: ''
              }
            })
          }
        },
        {
          title: '產品名稱',
          value: 'product_code',
          type: 'select',
          options: this.productOptions,
          optionDisplay: result => option => option.category === result.category,
          placeholder: () => '請選擇產品'
        },
        {
          title: '國家',
          value: 'countries',
          type: 'datalist',
          lists: value => this.countryOptions.map(option => option.title),
          placeholder: () => '請選擇國家',
          onChange: value => {
            if (value && !this.countryOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                countries: ''
              }
            }
          }
        },
        {
          title: '分析模組',
          value: 'module',
          type: 'select',
          options: this.moduleOptions,
          placeholder: () => '請選擇分析模組'
        },
        {
          title: '年份',
          value: 'year',
          type: 'select',
          options: this.yearOptions,
          placeholder: () => '請選擇年份'
        }
      ]
    },
    tableOptions () {
      return [
        {
          title: '發表時間',
          value: 'publish_time',
          width: '150px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : ''
        },
        {
          title: '報告標題',
          value: 'title',
          width: '350px'
        },
        {
          title: '產品名稱',
          value: 'product_name',
          width: '230px',
          display: value => value || '其他'
        },
        {
          title: '國家',
          value: 'countries',
          width: '200px',
          display: value => this.countryOptions.filter(option => value.includes(option.value)).map(option => option.country.chinese_name).join(', ')
        },
        {
          title: '分析模組',
          value: 'module',
          width: '150px',
          display: value => (this.moduleOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '年份',
          value: 'year',
          width: '100px',
          display: value => value || '無'
        },
        {
          title: '管理',
          value: '_OPTIONS',
          class: ['center-block'],
          sort: false
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchProductByCategorys()
      await this.fetchAdminReports()
    },
    async fetchProductByCategorys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getProductByCategorys(config)
        let productByCategorys = response.data
        this.productByCategorys = productByCategorys
      } catch (error) {
        throw error
      }
    },
    async fetchAdminReports (filters) {
      try {
        let config = this.$ls.get('userInfo')
        filters = filters || this.filters || {}
        let data = {
          ...Object.entries(filters).filter(kv => kv[1]).reduce((s, kv) => ({ ...s, [kv[0]]: kv[1] }), {}),
          year: filters.year === '無' ? '' : (filters.year || null),
          product_code: filters.product_code === '其他' ? '' : (filters.product_code || null),
          countries: (this.countryOptions.find(option => option.title === filters.countries) || {}).value || null
        }
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getAdminReports(data, config)
        let reports = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.reports = reports
      } catch (error) {
        throw error
      }
    },
    async searchDatas (init) {
      this.onSearch = true
      if (init) {
        this.init = init
        this.filter = init
      }
      await this.fetchAdminReports(init)
      this.onSearch = false
    },
    editReport (report) {
      this.setModalAction({
        action: 'editReport',
        width: '900px',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          title: report ? '編輯分析報告' : '新增分析報告',
          data: report,
          editable: true
        },
        callback: async result => {
          if (result) {
            this.searchDatas()
          }
        }
      })
    },
    deleteAdminReport (report) {
      this.setModalAction({
        action: 'toast',
        customStyles: {
          padding: '0px'
        },
        param: {
          type: 'error',
          content: '<span>此動作不可復原，<br>確認是否刪除文章: ' + report.title + ' ?</span>',
          buttons: [
            {
              title: '取消',
              type: 'gray',
              icon: 'fa-repeat',
              result: false
            },
            {
              title: '刪除',
              type: 'alert',
              icon: 'fa-trash-o',
              result: true
            }
          ]
        },
        callback: async result => {
          if (result) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let id = report.id
              await deleteAdminReport(id, config)
              this.addToast('success', '刪除成功')
              this.reports.splice(this.reports.indexOf(report), 1)
              this.setLoadingAction(false)
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data)
              this.setLoadingAction(false)
            }
          }
        }
      })
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/adminReport.vue